import { createRouter, createWebHistory } from 'vue-router';
import About from './About.vue';
import Team from './Team.vue';
import Contact from './Contact.vue';

const routes = [
  {
    path: '/about',
    children: [
      { path: 'team', component: Team },
      { path: 'contact', component: Contact }
    ]
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;